import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {OccupationalProfileService} from './occupational-profile.service';
import {OccupationalProfile} from '../shared/occupational-profile';
import {Observable, ReplaySubject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {ConfigService} from '../config/config.service';
import {Config} from '../shared/orientationtest-config/config';
import {ErrorNotifierService} from '../core/error-notifier.service';
import {Error} from '../shared/error'

@Component({
    selector: 'occupational-profile',
    templateUrl: './occupational-profile.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OccupationalProfileComponent implements OnInit {
	public occupationalProfileSubject = new ReplaySubject<OccupationalProfile>();
    public occupationalProfileObservable = this.occupationalProfileSubject.asObservable();
    public configObservable!: Observable<Config>;
    public hasTechnicalError = false;

    constructor(private route: ActivatedRoute,
                private occupationalProfileService: OccupationalProfileService,
                private configService: ConfigService,
                private errorNotifierService: ErrorNotifierService,
                private router: Router) {
    }

    ngOnInit(): void {
		this.configObservable = this.configService.getConfig();
        this.initTechnicalError();
        this.initiateOccupationalProfile();
    }

    private initiateOccupationalProfile(): void {
        let id = '';
        this.route.params.pipe(
            filter((params: Params) => params['id']))
			.subscribe(params => {
				id = params['id'];
				this.occupationalProfileService.getOccupationProfileById(id).subscribe({
					next: occupationProfile => {
						this.occupationalProfileSubject.next(occupationProfile);
					},
					error: e => {
						if (e.status < 500) {
							this.router.navigateByUrl('/beroepnietgevonden');
						}
					}
				})
			});
    }

    private initTechnicalError(): void {
        this.errorNotifierService.onError((err: Error) => {
            this.setError(err);
        });
        this.errorNotifierService.onTimedError((err: Error) => {
            this.setError(err);
            setTimeout(() => this.setError(null), 5000);
        });
        this.errorNotifierService.onClearError(() => this.setError(null));
    }
    private setError(error: Error | null): void {
        this.hasTechnicalError = !!error;
    }
}
